export enum InvoiceStatus {
  Open = 2,
  Paid,
}

export interface Invoice {
  readonly created: Date;
  readonly currency: string;
  readonly description: string;
  readonly paymentUrl: string;
  readonly status: InvoiceStatus;
  readonly totalAmount: number;
  readonly updated: Date;
}
